module.exports = __webpack_public_path__ + "static/media/chart-pie-fill.ccb8a013.svg";